import React from 'react';
import { Badge, Space, Tag, Tooltip } from 'antd';
import { SyncOutlined } from '@ant-design/icons';

const ChecklistStatusIndicator = ({ checklist, compact = false }) => {
    const customFieldsCount = checklist.custom_fields?.length || 0;
    const amoFieldsCount = checklist.fields_ids?.length || 0;
    const syncedFieldsCount = checklist.custom_fields?.filter(cf => 
        cf.type !== 'C' && cf.name 
    ).length || 0;



    if (compact) {
        return (
            <Space size={4}>
                <Badge 
                    count={customFieldsCount} 
                    size="small" 
                    color="#1890ff" 
                    title="Кастомные поля"
                    style={{ backgroundColor: customFieldsCount > 0 ? '#1890ff' : '#d9d9d9' }}
                />
                <Badge 
                    count={amoFieldsCount} 
                    size="small" 
                    color="#52c41a" 
                    title="AMO поля"
                    style={{ backgroundColor: amoFieldsCount > 0 ? '#52c41a' : '#d9d9d9'  }}
                />
                {syncedFieldsCount > 0 && (
                    <Badge 
                        count={syncedFieldsCount} 
                        size="small" 
                        color="#722ed1" 
                        title="Синхронизированные поля"
                    />
                )}
            </Space>
        );
    }

    return (
        <Space size="middle" style={{ width: '100%' }}>
            <Tooltip title={`Кастомные поля: ${customFieldsCount}`}>
                <Badge 
                    count={customFieldsCount} 
                    size="small" 
                    color="#1890ff"
                    overflowCount={99}
                />
            </Tooltip>
            
            <Tooltip title={`AMO поля: ${amoFieldsCount}`}>
                <Badge 
                    count={amoFieldsCount} 
                    size="small" 
                    color="#52c41a"
                    overflowCount={99}
                />
            </Tooltip>

            {syncedFieldsCount > 0 && (
                <Tag color="#722ed1" icon={<SyncOutlined />} size="small">
                    {syncedFieldsCount} синхронизировано
                </Tag>
            )}
        </Space>
    );
};

export default ChecklistStatusIndicator; 